import { Users, ShieldCheck, MapPin, CalendarClock, BadgeCheck, ClipboardCheck } from "lucide-react";
import { TRUST_BADGES } from "@/data/content";

const ICONS = { Users, ShieldCheck, MapPin, CalendarClock, BadgeCheck, ClipboardCheck };

export const TrustMarquee = () => {
  const items = [...TRUST_BADGES, ...TRUST_BADGES];
  return (
    <section data-testid="trust-marquee" className="bg-stoneaccent py-5 overflow-hidden border-y border-black/5">
      <div className="flex w-max animate-marquee">
        {items.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <div key={i} className="flex items-center gap-3 px-8 shrink-0">
              <Icon className="w-5 h-5 text-brick" strokeWidth={2} />
              <span className="font-heading font-bold text-charcoal text-base whitespace-nowrap">{b.label}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-brick/40 ml-4" />
            </div>
          );
        })}
      </div>
    </section>
  );
};
